import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ArtifactSummary } from '../../forgeApi.types'

export interface ReviewArtifactRequest {
  publicId: string
  decision: 'approve' | 'decline'
  reason?: string
  // On approve: the confirmed external hosts this widget's CSP will permit.
  allowedHosts?: string[]
}

interface ReviewArtifactResponse {
  artifact: ArtifactSummary
}

const reviewArtifact = async ({
  publicId,
  decision,
  reason,
  allowedHosts
}: ReviewArtifactRequest): Promise<ArtifactSummary> => {
  const response = await forgeApi.post<ReviewArtifactResponse>(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/review`,
    { decision, reason, allowed_hosts: allowedHosts }
  )
  return response.data.artifact
}

export const useReviewArtifactMutation = (
  options?: ExtendableMutationOptions<ArtifactSummary, ReviewArtifactRequest>
) =>
  useMutation({
    mutationFn: reviewArtifact,
    ...options
  })
